/**
 * Manifest icon names → the glyph each chrome variant draws (SDD-012, U-4).
 *
 * MIRRORED from `docs/domain/legacy-handoff/icon-map.json` (`manifestIconNames`); the test beside
 * this file asserts equality, so the two cannot drift. Keys are the `feather:<glyph>` names the
 * manifests use; values are the `@mui/icons-material` component the Berry variant substitutes.
 */
export const featherToMui: Readonly<Record<string, string>> = {
  package: 'Inventory2Icon',
  layers: 'AccountTreeIcon',
  briefcase: 'HandshakeIcon',
  box: 'GavelIcon',
  'file-text': 'DescriptionOutlinedIcon',
  users: 'PeopleIcon',
  home: 'FolderIcon',
  'arrow-left': 'ArrowBack',
  // The Data Suite's menu (SDD-024 A-5): Berichte, Datensätze, Einstellungen.
  'bar-chart-2': 'BarChartOutlinedIcon',
  database: 'StorageOutlinedIcon',
  settings: 'SettingsIcon',
};

export const FEATHER_PREFIX = 'feather:';
